import React from 'react'
import { Helmet } from 'react-helmet'
import Userstory from '../components/userstory/Userstory'

const UserstoryPage = () => {
  return (
    <>
      <Helmet>
        <title>Success Stories - Nand Blogs</title>
        <meta name="description" content="Discover real-world Salesforce success stories and case studies. Learn how businesses achieved remarkable results with our Salesforce implementations and solutions." />
        <meta name="keywords" content="Salesforce success stories, Salesforce case studies, CRM implementation, Salesforce consulting, business transformation, Salesforce solutions" />
        <link rel="canonical" href="https://nandblogs.com/success-story" />
        
        {/* Apollo Tracking Script */}
        <script>
          {`
            function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script");
            o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0,
            o.onload=function(){window.trackingFunctions.onLoad({appId:"67ef84d35ff339001db5ffa8"})},
            document.head.appendChild(o)}initApollo();
          `}
        </script>
      </Helmet>
      <Userstory />
    </>
  )
}

export default UserstoryPage